import React from "react";
import { StyledButton } from "../../Common/Components";
import PermissionCheck from "../../Common/PermissionCheck";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import EditStage from "./EditStage";

const PermissionName = PermissionNames.STAGE;

export const getColumns = ({ formatMessage, handleDeleteIntent, refetch }) => [
  {
    title: formatMessage({
      id: "name.local",
      defaultMessage: "Local Name",
    }),
    dataIndex: "nameLocal",
  },
  {
    title: formatMessage({
      id: "abbreviationLocal",
      defaultMessage: "Stage abbr",
    }),
    dataIndex: "abbreviationLocal",
  },
  {
    title: formatMessage({
      id: "stage.order",
      defaultMessage: "Stage Order",
    }),
    dataIndex: "stageOrder",
    sorter: (a, b) => a.stageOrder - b.stageOrder,
  },
  {
    title: `${formatMessage({
      id: "external",
      defaultMessage: "External",
    })} ID`,
    dataIndex: "externalId",
  },
  {
    align: "right",
    render: (value, row) => (
      <>
        <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.UPDATE]}>
          <EditStage stageCode={value?.stageCode} refetch={refetch} />
        </PermissionCheck>
        <PermissionCheck permissionKeys={[PermissionName]} permissionOptions={[PermissionOperations.DELETE]}>
          <StyledButton
            icon={<i className={"fas fa-trash"} />}
            type="text"
            size="small"
            onClick={() => handleDeleteIntent(row.stageCode)}
          />
        </PermissionCheck>
      </>
    ),
  },
];
